function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Moon Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.5,8.5 C6.5,11.4854957 8.39206312,14.1095657 11.1669775,15.0927055 C11.6107558,15.2499342 11.6110911,15.877413 11.1674811,16.0351158 C10.3079084,16.3406928 9.41240874,16.5 8.5,16.5 C4.08185763,16.5 0.5,12.9181424 0.5,8.5 C0.5,4.08185763 4.08185763,0.5 8.5,0.5 C9.41031281,0.5 10.3053111,0.659486074 11.1669459,0.964694291 C11.6110741,1.12201338 11.6109993,1.75013216 11.1668336,1.90734546 C8.39240088,2.88936117 6.5,5.51416656 6.5,8.5 Z M5.5,8.5 C5.5,5.58732369 7.07494122,2.97565437 9.50689894,1.57494821 C9.1741726,1.52526375 8.83818021,1.5 8.5,1.5 C4.63414237,1.5 1.5,4.63414237 1.5,8.5 C1.5,12.3658576 4.63414237,15.5 8.5,15.5 C8.83883542,15.5 9.175133,15.4748069 9.50775802,15.4252259 C7.07511247,14.0241276 5.5,11.412793 5.5,8.5 Z",
  id: "moon-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "moon-Icon/Global/sleep",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "moon-Swatches/Midnight",
  transform: "translate(6.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "moon-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#moon-path-1"
})));

var SvgMoon = function SvgMoon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon.079406f2.svg";
export { ForwardRef as ReactComponent };